<div #employeeListScroller (scroll)="onScroll()" [ngClass]="isLoading ? 'employee-list-wrapper loading' : 'employee-list-wrapper'">
	@for (employee of employeeList; track employee.internalUserGUID) {
		<div [ngClass]="selectedEmployeeGUID === employee.internalUserGUID ? 'employee selected' : 'employee'" (click)="selectEmployee(employee.internalUserGUID)">
			<img class="employee-img" [src]="employee.imageSrc ?? defaultProfileImage" />
			<div class="employee-information">
				<p class="employee-name">{{ employee.name }}</p>
				@if (employee.location || employee.jobTitle) {
					<div class="employee-details">
						@if (employee.jobTitle) {
							<div class="employee-field">
								<mat-icon class="material-icons-outlined icon">work_outline</mat-icon>
								<p>{{ employee.jobTitle }}</p>
							</div>
						}
						@if (employee.location) {
							<div class="employee-field">
								<mat-icon class="material-icons-outlined icon">business</mat-icon>
								<p>{{ employee.location }}</p>
							</div>
						}
					</div>
				}
			</div>
			@if (callUser && employee.workPhone && loggedInUser?.internalUserGUID !== employee.internalUserGUID) {
				<button [ngClass]="isUserOnCallInput ? 'primary full-width' : 'primary'" (click)="handleCallUser($event, employee.workPhone)">
					<mat-icon class="material-icons-outlined icon">phone</mat-icon>{{ isUserOnCallInput ? ' Transfer Call' : ' Call' }}
				</button>
			}
		</div>
	}
</div>
